module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "preview"
    }
  }, [_c('section', {
    staticClass: "profile"
  }, [_c('h1', [_vm._v(_vm._s(_vm.resume.profile.name || '请填写姓名'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.resume.profile.citry || '请填写城市') + " ")]), _vm._v("|\n            "), _c('small', [_vm._v(_vm._s(_vm.resume.profile.birth || '请填写出生年月'))])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.filter(_vm.resume.workHistory).length > 0) ? _c('section', {
    staticClass: "workHistory"
  }, [_c('h2', [_vm._v("工作经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.resume.workHistory), function(work) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(work.company) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(work.content))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.filter(_vm.resume.projects).length > 0) ? _c('section', {
    staticClass: "projects"
  }, [_c('h2', [_vm._v("前端项目")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.projects)), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.content))])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "split"
  }), _vm._v(" "), (_vm.filter(_vm.resume.school).length > 0) ? _c('section', {
    staticClass: "school"
  }, [_c('h2', [_vm._v("学习经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.school)), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(item.major))])])
  }))]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "contact"
  }, [_c('h2', [_vm._v("联系方式")]), _vm._v(" "), _c('p', [_vm._v("手机:\n                "), _c('span', [_vm._v(_vm._s(_vm.resume.contact.phone || '请填写手机号码'))])]), _vm._v(" "), _c('p', [_vm._v("微信:\n                "), _c('span', [_vm._v(_vm._s(_vm.resume.contact.wechat || '请填写微信号码'))])]), _vm._v(" "), _c('p', [_vm._v("邮箱:\n                "), _c('span', [_vm._v(_vm._s(_vm.resume.contact.email || '请填写电子邮箱'))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4456e20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview/Preview.vue
// module id = 203
// module chunks = 1